export const DEFAULT_ERROR_STATUS = 500

export const DEFAULT_ERROR_MESSAGE = 'Internal Server Error'
